export const NEW_CHAT_TITLE_DEFAULT = 'NEW_CHAT_TITLE_DEFAULT';
export const LOADING_TIME_FOR_MESSAGE = 550;
